<template>
  <div class="page-bg">
    <div class="card search-card">
      <!-- 搜索区域 -->
      <el-form size="small" label-width="100px" class="margin15-tb" @submit.native.prevent>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="公司名称">
              <el-select v-model="search.companyId" placeholder="请选择公司" clearable @change="onSearchCompanyChange" filterable style="width: 100%">
                <el-option v-for="item in searchCompanyList" :key="item.id" :label="item.companyName" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推送类型">
              <el-select v-model="search.pushType" placeholder="请选择推送类型" clearable style="width: 100%">
                <el-option v-for="(value, key) in pushTypeMap" :key="key" :label="value" :value="key" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推送状态">
              <el-select v-model="search.status" placeholder="请选择推送状态" clearable style="width: 100%">
                <el-option label="成功" :value="1" />
                <el-option label="失败" :value="0" />
                <el-option label="等待" :value="2" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="进件号" prop="aCaseId">
              <el-input
                v-model="search.aCaseId"
                placeholder="请输入进件号"
                clearable
                style="width: 100%"
                @keyup.enter.native="handleSearch"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推送标识" prop="sessionId">
              <el-input style="width:100%" v-model="search.sessionId" controls-position="right" placeholder="请输入推送标识" @keyup.native="numberDays"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="推送时间">
              <el-date-picker
                v-model="searchTimeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <div class="padding15-tb text right">
            <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
            <el-button size="mini" @click="handleReset">重置</el-button>
          </div>
        </el-row>
      </el-form>
    </div>
    <div class="card table-card">
      <!-- 批量补推按钮 -->
      <div class="table-header">
        <el-button type="primary" icon="el-icon-refresh" size="small" @click="handleBatchPush">
          批量补推
        </el-button>
      </div>
      <!-- 表格区域 -->
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        style="width:100%"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <el-table-column prop="companyId" label="公司" align="center">
          <template slot-scope="scope">
            <span>{{ getCompanyName(scope.row.companyId) || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pushType" label="类型" align="center">
          <template slot-scope="scope">
            <span>{{ pushTypeMap[scope.row.pushType] || scope.row.pushType || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pushResult" label="推送结果" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.pushResult || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pushCount" label="推送次数" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pushCount || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="失败原因" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.reason || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pushData" label="推送参数" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.pushData || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="推送时间" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleSinglePush(scope.row)">
              <i class="el-icon-refresh" style="margin-right:4px;"></i>补推
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 16px; text-align: center"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      list: [], // 当前展示数据
      search: {
        companyId: '',
        pushType: '',
        status: '',
        startTime: '',
        endTime: '',
        sessionId: null,
        aCaseId: '' // 添加进件号搜索字段
      },
      searchTimeRange: this.getTodayRange(), // 时间范围选择器绑定值，默认为当天
      searchCompanyList: [], // 搜索用公司列表
      pushTypeMap: {
        'ivr': '语音',
        'msg': '短信',
        'svoice': '场景语音'
      },
      // 分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    fetchList() {
      this.loading = true;
      // 处理时间范围
      if (this.searchTimeRange && this.searchTimeRange.length === 2) {
        this.search.startTime = this.searchTimeRange[0];
        this.search.endTime = this.searchTimeRange[1];
      } else {
        this.search.startTime = '';
        this.search.endTime = '';
      }
      this.$ajax({
        url: '/pushRecord/getRecordList',
        method: 'POST',
        data: {
          start: (this.currentPage - 1) * this.pageSize,
          limit: this.pageSize,
          companyId: this.search.companyId,
          pushType: this.search.pushType,
          status: this.search.status,
          startTime: this.search.startTime,
          endTime: this.search.endTime,
          aCaseId: this.search.aCaseId,
          sessionId: this.search.sessionId
        }
      }).then((res) => {
        const data = res.data.list || res.data || [];
        this.list = data;
        this.total = res.data.totalRecords || 0;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    fetchAllRecords() {
      // 处理时间范围
      if (this.searchTimeRange && this.searchTimeRange.length === 2) {
        this.search.startTime = this.searchTimeRange[0];
        this.search.endTime = this.searchTimeRange[1];
      } else {
        this.search.startTime = '';
        this.search.endTime = '';
      }
      return this.$ajax({
        url: '/pushRecord/getRecordList',
        method: 'POST',
        data: {
          start: 0,
          limit: 999999, // 获取所有数据
          companyId: this.search.companyId,
          pushType: this.search.pushType,
          status: this.search.status,
          startTime: this.search.startTime,
          endTime: this.search.endTime,
          aCaseId: this.search.aCaseId
        }
      });
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchList();
    },
    handleReset() {
      this.search.companyId = '';
      this.search.pushType = '';
      this.search.status = '';
      this.search.startTime = '';
      this.search.endTime = '';
      this.search.aCaseId = ''; // 重置进件号
      this.searchTimeRange = [];
      this.currentPage = 1;
      this.fetchList();
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchList();
    },
    handleSinglePush(row) {
      this.$confirm('是否重新补推？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 单个补推接口调用
        this.$ajax({
          url: '/pushRecord/rePushRecords',
          method: 'POST',
          data: [{
            companyId: row.companyId,
            sessionId: row.sessionId,
            channelType: row.pushType
          }]
        }).then((res) => {
          // 检查响应状态码
          if (res && (res.code === 200 || (res.data && res.data.code === 200))) {
            this.$message.success('补推成功');
            this.fetchList();
          } else {
            this.$message.error('补推失败');
          }
        }).catch(() => {
          this.$message.error('补推失败');
        });
      }).catch(() => {
        // 用户取消，无需处理
      });
    },
    handleBatchPush() {
      if (this.total === 0) {
        this.$message.warning('当前没有可补推的记录');
        return;
      }
      this.$confirm(`确定要批量补推搜索结果的 ${this.total} 条记录吗？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 获取所有搜索结果进行补推
        this.fetchAllRecords().then((res) => {
          const allRecords = res.data.list || res.data || [];
          if (allRecords.length === 0) {
            this.$message.warning('没有找到可补推的记录');
            return Promise.resolve();
          }
          // 批量补推接口调用
          const pushRecords = allRecords.map(row => ({
            companyId: row.companyId,
            sessionId: row.sessionId,
            channelType: row.pushType
          }));
          return this.$ajax({
            url: '/pushRecord/rePushRecords',
            method: 'POST',
            data: pushRecords
          });
        }).then((res) => {
          // 检查响应状态码
          if (res && (res.code === 200 || (res.data && res.data.code === 200))) {
            this.$message.success('批量补推成功');
            this.fetchList();
          } else {
            this.$message.error('批量补推失败');
          }
        }).catch(() => {
          this.$message.error('批量补推失败');
        });
      }).catch(() => {
        // 用户取消，无需处理
      });
    },
    getStatusType(status) {
      switch (status) {
        case 1: return 'success';
        case 0: return 'danger';
        case 2: return 'warning';
        default: return 'info';
      }
    },
    getStatusText(status) {
      switch (status) {
        case 1: return '成功';
        case 0: return '失败';
        case 2: return '等待';
        default: return '未知';
      }
    },
    getSearchCompanyList() {
      this.$ajax({ url: '/company/getAllValidCompany', method: 'GET' }).then((res) => {
        this.searchCompanyList = res.data || [];
      });
    },
    getCompanyName(companyId) {
      const company = this.searchCompanyList.find(item => item.id === companyId);
      return company ? company.companyName : companyId;
    },
    headerCellStyle() {
      return {
        background: '#eef3ff',
        color: '#333',
        fontWeight: 'normal',
        textAlign: 'center'
      };
    },
    cellStyle() {
      return {
        textAlign: 'center'
      };
    },
    getTodayRange() {
      const today = new Date();
      const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
      const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      };
      return [formatDate(startOfDay), formatDate(endOfDay)];
    },
    numberDays() {
      this.search.sessionId = this.search.sessionId.replace(/[^\\.\d]/g, '');
      this.search.sessionId = this.search.sessionId.replace('.', '');
    }
  },
  mounted() {
    this.fetchList();
    this.getSearchCompanyList();
  }
};
</script>

<style scoped>
.page-bg {
  background: #f5f7fa;
  min-height: 100vh;
  padding: 24px;
}
.card {
  background: #fff;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
  margin-bottom: 24px;
  padding: 24px;
}
.search-card {
  margin-bottom: 16px;
}
.table-card {
  padding-top: 16px;
}
.table-header {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/page/main/system/pushRecord.vue